// Monthly hours pack → weekly cadence. Mirrors backend
// `SubscriptionHelperV2::SOLD_CADENCE` — school-year tiers 1h → 5h/sem plus the
// Cours d'été tiers 6h → 10h/sem — so we don't drift if the grid evolves.
// Off-grid packs (legacy or admin custom grids) fall back to `~hours/4.35`.
export const HOURS_PER_MONTH_TO_PER_WEEK = {
    4: 1,
    6: 1.5,
    9: 2,
    13: 3,
    17: 4,
    22: 5,
    26: 6,
    30: 7,
    35: 8,
    39: 9,
    43: 10,
}

export const weeklyHoursFromMonthly = (hoursPerMonth) => {
    if (!hoursPerMonth || hoursPerMonth <= 0) return 0
    return (
        HOURS_PER_MONTH_TO_PER_WEEK[hoursPerMonth] ??
        Math.round((hoursPerMonth / 4.35) * 10) / 10
    )
}

// Inverse of the backend plan label ("Cours d'été - 10h par semaine" → 10,
// "Cours particuliers - 1h30 par semaine" → 1.5). Never read the cadence
// character by character: "10h" then yields 1 and caps a 10 h/sem family at a
// single hour. Returns null when the label carries no cadence segment.
export const weeklyHoursFromPlanLabel = (plan) => {
    const cadence = (plan || "").split(" - ")[1]?.trim() ?? ""
    const matches = cadence.match(/^(\d+)h(\d{1,2})?/)
    if (!matches) return null
    return parseInt(matches[1]) + (matches[2] ? parseInt(matches[2]) / 60 : 0)
}

// Commercial label of the plan that actually governs the student: the current
// plan unless it's the legacy "Basic" placeholder, then the planned reprise
// plan (a paused student has no current plan). Null when neither exists.
export const effectivePlanLabel = (subscriptionState) =>
    (!!subscriptionState?.plan && subscriptionState?.plan !== "Basic"
        ? subscriptionState?.plan
        : subscriptionState?.planned_plan) ?? null

/**
 * Whole weekly hours a plan provides, the capacity objective allocations are
 * checked against. Mirrors backend `PedagogicalObjectiveService::parseHoursPerWeek`:
 * exact `hours_per_month` first, plan label only as a fallback (the planned
 * reprise plan of a paused student has no hours field).
 */
export const weeklyHoursCapacity = (subscriptionState, fallback = 2) => {
    const hoursPerMonth = subscriptionState?.hours_per_month
    if (hoursPerMonth) {
        return Math.floor(weeklyHoursFromMonthly(hoursPerMonth)) || fallback
    }

    const plan = effectivePlanLabel(subscriptionState)
    return Math.floor(weeklyHoursFromPlanLabel(plan) ?? 0) || fallback
}
